<div class="convert-pin-dialog-container">
    <div class="convert-pin-dialog-header-container">
        <div>  <p class="convert-pin-dialog-header-text convert-pin-section-headers">{{ 'CONVERT-PIN-DIALOG.COVERT-PIN' | translate }}</p></div>
        <div><p class="convert-pin-dialog-sub-heading">{{ 'CONVERT-PIN-DIALOG.TITLE' | translate }}</p></div>
    </div>

    <div class="convert-pin-btn-dialog-container">

        <button class="cancel-convert-pin-dialog-btn" mat-flat-button type="button" (click)="close()">
            <div class="cancel-convert-pin-btn-content">
                <span><p class="cancel-convert-pin-btn-text">{{ 'CONVERT-PIN-DIALOG.CANCEL' | translate }}</p></span>
            </div>
        </button>

        <button class="convert-pin-btn" mat-flat-button type="button" (click)="covertMarkerPinToVc()">
            <div class="convert-pin-btn-content">
                <span><p class="convert-pin-btn-text">{{ 'CONVERT-PIN-DIALOG.COVERT' | translate }}</p></span>
            </div>
        </button>
    </div>

</div>



